import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHouseSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.537 4.155 12 3.813l-.537.342-7.002 4.456-.463.294v11.097h16.004V8.905l-.463-.294-7.002-4.456ZM9.25 12.75h5.5v2h-5.5v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHouseSharpFill);
export default Memo;
